import { render, staticRenderFns } from "./SignatureDetails.vue?vue&type=template&id=1c21de2a&"
import script from "./SignatureDetails.vue?vue&type=script&lang=js&"
export * from "./SignatureDetails.vue?vue&type=script&lang=js&"
import style0 from "./SignatureDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports